// extracted by mini-css-extract-plugin
module.exports = {"SectionSubTitle":"SectionSubTitle_SectionSubTitle___EgJ_"};